import { useEffect, useRef, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './index.css';

// Set up the PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const ContentBusinessPlan = () => {
    const [numPages, setNumPages] = useState(null);

    const containerRef = useRef(null);
    const [pageWidth, setPageWidth] = useState(800);

    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                setPageWidth(containerRef.current.offsetWidth);
            }
        };

        updateWidth();
        window.addEventListener('resize', updateWidth);

        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    return (
        <div className='text-white'>
            <div className='mb-4 text-center'>

                <div className='mb-3'>
                    <p className='mb-1'>
                        <span className='fw-bold text-primary'>Idea:</span>{' '}
                        Make a business plan about a coffee house
                    </p>
                    <p className='mb-1'>
                        <span className='fw-bold text-primary'>Country:</span>{' '}
                        United States of America
                    </p>
                    <p className='mb-1'>
                        <span className='fw-bold text-primary'>Budget Range:</span>{' '}
                        USD 5,000 - USD 25,000
                    </p>
                </div>
            </div>

            {/* PDF Viewer */}
            <div
                className='d-flex justify-content-center'
                style={{ marginBottom: '40px' }}
            >
                <div ref={containerRef} style={{ maxWidth: '800px', width: '100%' }}>
                    <Document
                        file={`https://backend.whalesai.com/public/hiwvideos/business-plan-ai.pdf`}
                        onLoadSuccess={onDocumentLoadSuccess}
                        loading={
                            <div className='text-center py-5'>
                                <div
                                    className='spinner-border text-light'
                                    role='status'
                                    style={{ width: '3rem', height: '3rem' }}
                                >
                                    <span className='visually-hidden'>Loading PDF...</span>
                                </div>
                            </div>
                        }
                        error={
                            <div className='text-center text-danger py-5'>
                                Failed to load PDF. Please try again later.
                            </div>
                        }
                    >
                        {numPages &&
                            Array.from(new Array(numPages), (_, index) => (
                                <div
                                    key={`page_${index + 1}`}
                                    style={{
                                        marginBottom: '16px',
                                        borderRadius: '8px',
                                        overflow: 'hidden',
                                        border: '1px solid rgba(255,255,255,0.15)',
                                    }}
                                >
                                    <Page
                                        pageNumber={index + 1}
                                        width={pageWidth}
                                        renderTextLayer={true}
                                        renderAnnotationLayer={true}
                                    />
                                </div>
                            ))}
                    </Document>
                </div>
            </div>
        </div>
    );
};

export default ContentBusinessPlan;